module.exports = __webpack_public_path__ + "static/media/user-references-example.820718e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshots/user-references-example.png
// module id = 1781
// module chunks = 0